/**
 * Service to determine if the new year goal planning banner should be shown.
 * This will be moved to backend later.
 */

export interface GoalPlanningContext {
  shouldShow: boolean;
  reason?: string;
}

/**
 * Determines if the goal planning banner should be displayed.
 * Currently hardcoded, will be moved to backend.
 *
 * @returns Context object indicating if banner should show
 */
export const getGoalPlanningContext = (): GoalPlanningContext => {
  // Check if user has already completed the goal planning flow
  const completedFlow = localStorage.getItem('goal_planning_completed');
  if (completedFlow === 'true') {
    return {
      shouldShow: false,
      reason: 'User has already completed the goal planning flow',
    };
  }

  // Check if it's around new year (December - January)
  const now = new Date();
  const month = now.getMonth(); // 0-11, where 0 is January
  const isNewYearPeriod = month === 11 || month === 0; // December or January

  if (!isNewYearPeriod) {
    return {
      shouldShow: false,
      reason: 'Not in new year planning period',
    };
  }

  // For now, always show during new year period if not completed
  return {
    shouldShow: true,
    reason: 'New year goal planning period',
  };
};
